<template>
  <div class="modal fade" :class="{ show: isVisible }" tabindex="-1" 
       :style="{ display: isVisible ? 'block' : 'none' }">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Member Information</h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <!-- Avatar & Name -->
          <div class="member-header">
            <img :src="member.avatar || '/img/default-avatar.png'" class="member-avatar">
            <div class="member-name-section">
              <h4>{{ member.title }} {{ member.first_name }} {{ member.last_name }}</h4>
              <span class="member-id-badge">{{ member.alias_id }}</span>
            </div>
          </div>
          
          <!-- Info Grid -->
          <div class="info-grid">
            <div class="info-item">
              <label>Email</label>
              <span>{{ member.email }}</span>
            </div>
            <div class="info-item">
              <label>Phone</label>
              <span>{{ member.phone || '-' }}</span>
            </div>
            <div class="info-item">
              <label>Date of Birth</label>
              <span>{{ formatDate(member.date_of_birth) || '-' }}</span>
            </div>
            <div class="info-item">
              <label>Tier</label>
              <span>{{ member.tier_name && member.tier_name !== '-' ? (member.tier_name.length > 25 ? member.tier_name.substring(0, 25) : member.tier_name) : 'Member' }}</span>
            </div>
            <div class="info-item" v-if="isPointSystemActive">
              <label>Points</label>
              <span>{{ member.points || 0 }}</span>
            </div>
            <div class="info-item" v-if="isPointSystemActive && isPointValueVisibleToMember">
              <label>Point Balance</label>
              <span>IDR {{ formatCurrency(member.point_balance || 0) }}</span>
            </div>
          </div>
          
          <!-- Preference -->
          <div class="preference-section" v-if="member.preference">
            <label>Preferences</label>
            <p class="preference-text">{{ member.preference }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <o-button @click="close" :size="'block'" :variant="'outline-secondary'" :white="'white'">
            Close
          </o-button>
          <router-link v-if="member.id" :to="{ name: 'MemberEdit', params: { id: member.id } }" 
                       class="btn btn-primary">
            Edit Member
          </router-link>
          
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-if="isVisible" @click="close"></div>
</template>

<script>
import { usePointSystem } from '@/composables/pointsystem';
import { OButton } from '@/components/OmnihControl';

export default {
  name: 'MemberInfoModal',
  components: {
    OButton,
  },
  props: {
    isVisible: Boolean,
    member: Object
  },
  setup() {
    const { isPointSystemActive, isPointValueEnabled, isPointValueVisibleToMember } = usePointSystem();
    return {
      isPointSystemActive,
      isPointValueEnabled,
      isPointValueVisibleToMember
    };
  },
  watch: {
    isVisible(newVal) {
      document.body.style.overflow = newVal ? 'hidden' : '';
    }
  },
  mounted() {
    if (this.isVisible) {
      document.body.style.overflow = 'hidden';
    }
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    },
    formatDate(date) {
      if (!date) return null;
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric'
      });
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '0';
      return new Intl.NumberFormat('id-ID').format(value);
    }
  }
}
</script>

<style scoped>
.member-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.member-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}
.member-id-badge {
  font-family: monospace;
  font-size: 14px;
  background: #e3f2fd;
  padding: 4px 12px;
  border-radius: 4px;
  color: #1976d2;
  font-weight: 600;
}
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}
.info-item label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}
.info-item span {
  font-size: 14px;
  font-weight: 500;
}
.preference-section label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}
.preference-text {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  margin: 0;
}
.modal-footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 10px;
}
</style>
